// =============================================================================
// web/shims/react-native-haptic-feedback.js — WEB shim.
//
// No haptics on web. trigger() no-ops. Native iOS resolves the real package.
// =============================================================================
export function trigger() {}

export default { trigger };
